export default __webpack_public_path__ + "static/media/relay-race.076aa3d5.jpg";